import React from 'react';
import ReactDOM from 'react-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import App from './components/App';

const Root = () => 
  <>
    <App />
    <ToastContainer />
  </>;
;

ReactDOM.render(<Root />, document.getElementById('root'));
